import ProjectSelect from './project-select.vue';

export default ProjectSelect;
